import { collection, getDocs, limit, query } from "firebase/firestore";
import { runtimeDb as db } from "../../firestoreStudio/runtime/runtimeDb";

const PRESETS = {
  invoiceNumber: ["invoiceNo", "invoiceNumber", "invoice_no", "billNo"],
  employeeId: ["employeeId", "empId", "employee_id", "empCode"],
  barcode: ["barcode", "barCode", "sku"],
  deviceName: ["device_name", "deviceName", "device"],
};

export async function findDuplicates(collectionName, fieldName, sampleLimit = 2000) {
  const col = collectionName.trim();
  const snap = await getDocs(query(collection(db, col), limit(sampleLimit)));
  const groups = new Map();

  snap.docs.forEach((d) => {
    const val = d.data()?.[fieldName];
    if (val == null || val === "") return;
    const key = String(val);
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push({ id: d.id, data: d.data() });
  });

  const duplicates = [];
  groups.forEach((docs, value) => {
    if (docs.length > 1) duplicates.push({ value, count: docs.length, documents: docs });
  });

  return duplicates.sort((a, b) => b.count - a.count);
}

export function resolvePresetField(preset, availableFields) {
  const candidates = PRESETS[preset] || [preset];
  return candidates.find((c) => availableFields.includes(c)) || preset;
}
